"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * WindowFileOverviewDTOConverter.
 * @author OPt
 */


var WindowFileOverviewDTOConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(WindowFileOverviewDTOConverter, _DataObjectConverter_);

  function WindowFileOverviewDTOConverter() {
    _classCallCheck(this, WindowFileOverviewDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(WindowFileOverviewDTOConverter).apply(this, arguments));
  }

  return WindowFileOverviewDTOConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.WindowFileOverviewDTOConverter = WindowFileOverviewDTOConverter;